




































import Vue from 'vue';
import { getAssetPath } from '@/helpers/assets';
import i18n from '@/i18n';

export default Vue.extend({
  data() {
    return {
      maskUrl: getAssetPath('img/arrow.svg'),
    };
  },
  computed: {
    timeline(): {
      description: string;
      superTitle: string;
      media: { src: string; isVideo: boolean };
      title: string;
    }[] {
      return [
        {
          superTitle: i18n.t('timeline.one.superTitle'),
          title: i18n.t('timeline.one.title'),
          description: i18n.t('timeline.one.description'),
          media: { isVideo: false, src: getAssetPath('img/timeline/step1.jpg') },
        },
        {
          superTitle: i18n.t('timeline.two.superTitle'),
          title: i18n.t('timeline.two.title'),
          description: i18n.t('timeline.two.description'),
          media: { isVideo: false, src: getAssetPath('img/timeline/step2.jpg') },
        },
        {
          superTitle: i18n.t('timeline.three.superTitle'),
          title: i18n.t('timeline.three.title'),
          description: i18n.t('timeline.three.description'),
          media: { isVideo: false, src: getAssetPath('img/timeline/step3.jpg') },
        },
        {
          superTitle: i18n.t('timeline.four.superTitle'),
          title: i18n.t('timeline.four.title'),
          description: i18n.t('timeline.four.description'),
          media: { isVideo: false, src: getAssetPath('img/timeline/step4.jpg') },
        },
      ];
    },
  },
});
